import { createContext, useContext, useEffect, useRef } from "react";
import Lenis from "lenis";

const ScrollCtx = createContext(null);

export const SmoothScroll = ({ children }) => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    if (el && lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -70 });
    }
  };

  return <ScrollCtx.Provider value={{ scrollTo }}>{children}</ScrollCtx.Provider>;
};

export const useScrollTo = () => {
  const ctx = useContext(ScrollCtx);
  return ctx ? ctx.scrollTo : () => {};
};
